/**
 * Created by lihanying on 2017/7/7.
 */
import React from 'react'
import { Modal, Input, Select } from 'antd'
const Option = Select.Option

export default class extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      phoneError: {},
      phoneTypeIndex: 0,
      preInput: '',
    }
  }

  componentDidMount() {
    const { region, phone } = this.props.userInfo
    if (region) {
      //修改
      let phoneTypeIndex = 0
      this.props.regionList.forEach((v, index) => {
        if (v.id == region) {
          phoneTypeIndex = index
        }
      })
      const preInput = phone
      this.setState({ phoneTypeIndex, preInput }, () =>
        this.checkPhone(preInput)
      )
    }
  }

  checkPhone = (phone) => {
    let phoneNumber = phone.replace(/\D/g, '')
    const area = this.props.regionList[this.state.phoneTypeIndex] //当前选中的区域
    let phoneSize //当前选中区域的号码长度
    if (area.name == '中国内地') {
      phoneSize = 11
    } else if (area.name == '中国澳门' || area.name == '中国香港') {
      phoneSize = 8
    } else if (area.name == '中国台湾') {
      phoneSize = 10
    }

    const data = { preInput: phone } //setData的对象
    if (phoneNumber.length == phoneSize) {
      data.phoneError = { state: false, status: '' }
      data.phone = phoneNumber
      sessionStorage.setItem('phone', phoneNumber)
    } else if (phoneNumber.length > phoneSize) {
      data.phoneError = { state: true, status: `手机号码超过${phoneSize}位` }
    } else {
      data.phoneError = {
        state: true,
        status: `还有${phoneSize - phoneNumber.length}位`,
      }
    }
    this.setState(data)

    // return false;
  }
  render() {
    const { visible, userInfo, action, roleList, regionList } = this.props
    const { phoneTypeIndex } = this.state
    return (
      <div>
        <Modal
          title={action === '-1' ? '添加管理员' : '修改管理人信息'}
          visible={visible}
          onOk={() => {
            sessionStorage.setItem('region_id', regionList[phoneTypeIndex].id)
            this.props.handleOk()
          }}
          onCancel={this.props.handleCancel}
          width="600px"
        >
          <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
            {/*<div style={{marginTop:'1rem'}}>*/}
            {/*<span className="info-span">账号:</span>*/}
            {/*<Input size="large" defaultValue={userInfo.account} style={{width:'50%',marginLeft:'2.4rem'}} placeholder="请输入管理人账号"*/}
            {/*onChange={(e)=>sessionStorage.setItem('account',e.target.value)}/>*/}
            {/*</div>*/}
            {/*<div style={{marginTop:'1rem'}}>*/}
            {/*<span className="info-span">密码:</span>*/}
            {/*<Input type="password" size="large" style={{width:'50%',marginLeft:'2.4rem'}} placeholder={action === '-1'?"请设置管理员密码" :"请输入新的密码,可以不填写"}*/}
            {/*onChange={(e)=>sessionStorage.setItem('password',e.target.value)}/>*/}
            {/*</div>*/}
            <div style={{ marginTop: '1rem' }}>
              <span className="info-span">管理人名称:</span>
              <Input
                size="large"
                defaultValue={userInfo.belongto}
                style={{ width: '50%', marginLeft: '0.3rem' }}
                placeholder="请输入管理人的名字"
                onChange={(e) =>
                  sessionStorage.setItem('belongto', e.target.value)
                }
              />
            </div>
            <div style={{ marginTop: '1rem' }}>
              <span className="info-span">手机号码:</span>
              <Select
                size="large"
                value={phoneTypeIndex}
                style={{ paddingLeft: '1rem' }}
                onChange={(phoneTypeIndex) => {
                  this.setState({ phoneTypeIndex }, () => {
                    this.checkPhone(this.state.preInput)
                  })
                }}
              >
                {regionList &&
                  regionList.map((v, index) => {
                    return (
                      <Option key={index} value={index}>
                        {v.name}
                      </Option>
                    )
                  })}
              </Select>
              <Input
                size="large"
                defaultValue={userInfo.phone}
                pattern="1\d{10}"
                style={{ width: '32%' }}
                onChange={(e) => this.checkPhone(e.target.value)}
              />
              {this.state.phoneError.state ? (
                <i className="weui_icon_info">{this.state.phoneError.status}</i>
              ) : (
                ''
              )}
            </div>
            <div style={{ marginTop: '1rem' }}>
              <span className="info-span">分组:</span>
              <Select
                size="large"
                defaultValue={userInfo.role_id}
                placeholder="请选择一个分组"
                style={{ width: '50%', marginLeft: '2.5rem' }}
                onChange={(value) => sessionStorage.setItem('role_id', value)}
              >
                {roleList &&
                  roleList.map((item, idx) => {
                    return (
                      <Option value={item.id} key={idx}>
                        {item.name}
                      </Option>
                    )
                  })}
              </Select>
            </div>
          </div>
        </Modal>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/ClubUsers/component/modal.js